import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import { Warning } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { CardSurface } from '../../ui/CardSurface';
import { ButtonPrimary } from '../../ui/ButtonPrimary';

export function ConfirmarFinalizacaoModal({ open, onClose, onConfirm, bicosAferidos, bicosNaoAferidos }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '14px',
        },
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        <DialogTitle sx={{ textAlign: 'center', pb: 1, fontWeight: 600, pt: 3 }}>
          Confirmar Finalização
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 2,
            }}
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.1, type: 'spring', stiffness: 200 }}
            >
              <Warning
                sx={{
                  fontSize: 64,
                  color: 'warning.main',
                  mb: 3,
                }}
              />
            </motion.div>

            <Typography
              variant="body1"
              color="text.primary"
              sx={{ mb: 3, textAlign: 'center', fontWeight: 500 }}
            >
              Ainda faltam bicos serem aferidos.
            </Typography>

            <CardSurface
              sx={{
                width: '100%',
                p: 2.5,
                mb: 3,
                bgcolor: 'background.paper',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  Bicos aferidos:
                </Typography>
                <Typography variant="h6" fontWeight={700} color="success.main">
                  {bicosAferidos}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  Bicos não-aferidos:
                </Typography>
                <Typography variant="h6" fontWeight={700} color="error.main">
                  {bicosNaoAferidos}
                </Typography>
              </Box>
            </CardSurface>

            <Typography
              variant="body1"
              color="text.primary"
              sx={{ mb: 2, textAlign: 'center', fontWeight: 500 }}
            >
              Deseja mesmo finalizar a aferição?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'space-between' }}>
          <ButtonPrimary
            onClick={onClose}
            variant="outlined"
            size="large"
            sx={{
              minWidth: 120,
              borderColor: 'grey.300',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'grey.400',
                bgcolor: 'grey.50',
              },
            }}
          >
            Não
          </ButtonPrimary>
          <ButtonPrimary
            onClick={onConfirm}
            size="large"
            sx={{ minWidth: 120 }}
          >
            Sim
          </ButtonPrimary>
        </DialogActions>
      </motion.div>
    </Dialog>
  );
}
